module.exports = __webpack_public_path__ + "img/home-hero.f9433923.svg";